























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DashboardSidebar extends Vue {
  @Prop({ default: false }) readonly hasHeader!: boolean;
}
